import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Paper,
  Box,
  InputLabel,
  Select,
  FormControl,
  Card,
  Avatar,
  IconButton,
  FormHelperText,
  Snackbar,
  Alert,
} from "@mui/material";
import { PhotoCamera, AccountCircle, Cancel } from "@mui/icons-material";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { bloodGroupList } from "components/BloodGroupList";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import MDAutocomplete from "components/MDAutocomplete";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDTextField from "components/MDTextField";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { compressImage } from "utils/imageCompression";

export default function UserAdd() {
  const genders = [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
    { title: "Other", value: "Other" },
  ];

  const maritalStatuses = [
    { title: "Single", value: "Single" },
    { title: "Married", value: "Married" },
    { title: "Divorced", value: "Divorced" },
  ];

  const leaveEligibilityOptions = [
    { title: "Yes", value: "Yes" },
    { title: "No", value: "No" },
  ];
  const [loading, setLoading] = useState(false);

  const states = [{ title: "TamilNadu", value: "TamilNadu" }];
  const phoneRegExp = /^\d{10}$/;
  const bankaccountnumberRegExp = /^\d{9,18}$/;
  const { id: userId } = useParams();

  const validationSchema = () => {
    return Yup.object().shape({
      txtUserName: Yup.string()
        .required("User Name is required")
        .matches(/^[A-Za-z\s]+$/, "User Name must contain only letters"),

      intRoleID: Yup.string().required("Role is required"),

      txtEmail: Yup.string().required("Email Id is required").email("Must be a valid email"),

      intPhone: Yup.string()
        .required("Mobile Number is required")
        .matches(phoneRegExp, "Please Enter A Valid Mobile Number"),

      txtAddress: Yup.string().required("Permanent address is required"),

      txtDistrict: Yup.string().required("District is required"),

      intAadharno: Yup.string()
        .required("Aadhar Number is required")
        .matches(/^\d{12}$/, "Aadhar Number must be exactly 12 digits"),

      intPanNo: Yup.string()
        .required("PAN Number is required")
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "PAN Number must be in format GVJPD1225C"),

      txtQualification: Yup.string().required("Qualification is required"),

      // txtBio: Yup.string()
      //   // .required("Bio is required")
      //   .matches(/^[A-Za-z\s]+$/, "Bio must contain only letters")
      //   .max(300, "Bio must be at most 300 characters"),

      txtBankName: Yup.string()
        .nullable()
        .required("Bank Name is required")
        .matches(/^[A-Za-z\s]*$/, "Only letters are allowed")
        .max(50, "Maximum 50 characters"),

      txtIfscCode: Yup.string()
        .nullable()
        .required("IFSC Code is required")
        .matches(/^[A-Z|a-z]{4}0[A-Z0-9a-z]{6}$/, "IFSC must be 11 characters (e.g., SBIN0001234)"),

      txtBranch: Yup.string()
        .nullable()
        .required("Branch is required"),
        // .matches(/^[A-Za-z\s]*$/, "Only letters are allowed")
        // .max(50, "Maximum 50 characters"),

      txtAccountNumber: Yup.string()
        .nullable()
        .required("Account Number is required"),
        // .matches(/^\d{11,16}$/, "Account Number must be between 11 and 16 digits"),

      txtAccountName: Yup.string()
        .nullable()
        .required("Account Holder Name is required"),
        // .matches(/^[A-Za-z\s]*$/, "Only letters are allowed")
        // .max(20, "Maximum 20 characters"),
    });
  };
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();

  const handleImageUpload = (event) => {
    const file = event.currentTarget.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

    if (file && !allowedTypes.includes(file.type)) {
      alert("Only .jpeg, .jpg, and .png files are allowed");
      return;
    }

    if (file) {
      setImagePreview(URL.createObjectURL(file));
      formik.setFieldValue("profileImage", file);
    }
  };

  const handleImageRemove = () => {
    setImagePreview(null);
    formik.setFieldValue("profileImage", null);
  };

  const fetchRoles = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/roles/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: fetchedRoles,
    error: roleError,
    isLoading: roleIsLoading,
  } = useQuery({
    queryKey: ["fetchRoles"],
    queryFn: fetchRoles,
    retry: false,
  });

  const roleData =
    fetchedRoles?.map((role) => ({
      title: role.role_name,
      value: role.role_id,
    })) || [];

  const fetchDistrict = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/districts/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: districtData,
    error: districtError,
    isLoading: districtIsLoading,
  } = useQuery({
    queryKey: ["fetchDistrict"],
    queryFn: fetchDistrict,
    retry: false,
  });

  const fetchStatus = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/status/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: fetchedStatus,
    error: statusError,
    isLoading: statusIsLoading,
  } = useQuery({
    queryKey: ["fetchStatus"],
    queryFn: fetchStatus,
    retry: false,
  });

  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  const statusData =
    fetchedStatus?.map((status) => ({
      title: status.name,
      value: status.status_id,
    })) || [];

  const [state, setState] = useState({
    open: false,
    severity: "success",
    vertical: "top",
    horizontal: "right",
    message: "",
  });
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const { vertical, horizontal, open, message, severity } = state;

  const formik = useFormik({
    initialValues: {
      txtUserName: "",
      intRoleID: "",
      txtEmail: "",
      intPhone: "",
      txtAddress: "",
      txtDistrict: "",
      intAadharno: "",
      intPanNo: "",
      txtQualification: "",
      txtBio: "",
      txtBankName: "",
      txtIfscCode: "",
      txtBranch: "",
      txtAccountNumber: "",
      txtAccountName: "",
      profileImage: null,
      intStatus: "",
    },
    validationSchema: validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      console.log("🚀 ~ UserAdd ~ values:", values);

      try {
        setLoading(true);
        const authResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          {},
          { withCredentials: true }
        );

        const { role_id } = authResponse.data;

        if (!role_id) {
          console.error("Role ID not found from /auth/me response.");
          return;
        }

        const formData = new FormData();
        Object.keys(values).forEach((key) => {
          if (key === "txtDob" || key === "txtDateofJoin") {
            const formattedDate = values[key] ? dayjs(values[key]).format("YYYY-MM-DD") : "";
            formData.append(key, formattedDate);
          } else {
            formData.append(key, values[key]);
          }
        });

        if (values.profileImage === null) {
          formData.set("profileImage", "null"); // backend will treat this as string "null"
        } else if (values.profileImage instanceof File) {
          const compressedImage = await compressImage(values.profileImage);
          formData.set("profileImage", compressedImage); // send new uploaded file
        } else {
          formData.set("profileImage", values.profileImage); // existing URL or untouched string
        }
        if (!userId) {
          formData.set("created_by", role_id);
          formData.set("intStatus", "2");
        } else {
          formData.set("updated_by", role_id);
        }
        const url = userId
          ? `${process.env.REACT_APP_API_URL}/user/${userId}`
          : `${process.env.REACT_APP_API_URL}/user/add`;

        const method = userId ? "put" : "post";

        const response = await axios({
          method,
          url,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        });

        if (response.data.status === 200) {
          setState({
            ...state,
            open: true,
            severity: "success",
            message: response.data.message,
          });

          setTimeout(() => {
            if (userId && role_id === 3) {
              navigate("/profile");
            } else {
              navigate("/user-list");
            }
          }, 2000);
        }
      } catch (error) {
        console.error("Submission error:", error);
        setState({
          ...state,
          open: true,
          severity: "error",
          message: error?.response?.data?.error || "Submission failed",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (userId) {
      const fetchUserDetails = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
            withCredentials: true,
          });

          if (response.data.status === 200) {
            const user = response.data.data;

            formik.setValues({
              txtUserName: user.user_name || "",
              txtEmail: user.email || "",
              intPhone: user.phone || "",
              txtAddress: user.address || "",
              txtDistrict: user.district || "",
              intAadharno: user.aadhar_no || "",
              intPanNo: user.pan_no || "",
              txtQualification: user.qualification || "",
              txtBio: user.bio || "",
              txtBankName: user.bank_name || "",
              txtIfscCode: user.ifsc_code || "",
              txtBranch: user.branch || "",
              txtAccountNumber: user.account_number || "",
              txtAccountName: user.account_name || "",
              intStatus: user.status || "",
              intRoleID: user.role_id || "",
            });

            if (user.profile_image) {
              // setImagePreview(`${process.env.REACT_APP_API_URL}/${user.profile_image}`);
              setImagePreview(user.profile_image);
            }
          }
        } catch (error) {
          console.error("❌ Failed to fetch user details", error);
        }
      };

      fetchUserDetails();
    }
  }, [userId]);

  if (!isLoading) {
    // If role is USER (3) and trying to edit someone else's profile
    if (meData?.role_id === 3 && userId && parseInt(userId) !== meData.user_id) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          flexDirection="column"
        >
          <Typography variant="h4" color="error">
            403 - Unauthorized
          </Typography>
          <Typography>You are not authorized to edit this user profile.</Typography>
        </Box>
      );
    }

    // If role is USER (3) and trying to create a new user
    if (meData?.role_id === 3 && !userId) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          flexDirection="column"
        >
          <Typography variant="h4" color="error">
            403 - Unauthorized
          </Typography>
          <Typography>You are not authorized to access this page.</Typography>
        </Box>
      );
    }
  }

  return (
    <DashboardLayout>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
          style={{ color: "white" }}
        >
          {message}
        </Alert>
      </Snackbar>
      {/* <DashboardNavbar /> */}
      {/* <Card> */}
      {/* <MDBox pt={3} pb={3} px={3} maxWidth="1200px" mx="auto"> */}
      {/* <Typography variant="h5" gutterBottom>
            User Registration
          </Typography> */}
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
      {/* <form onSubmit={formik.handleSubmit}> */}
      {/* <Grid container spacing={2}> */}
      <Card id="delete-account">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{ textAlign: "center", mt: 2 }}
        >
          <Box position="relative">
            <Avatar src={imagePreview} sx={{ width: 100, height: 100, border: "2px solid #ccc" }} />

            {/* Show 📷 only if image not uploaded */}
            {!imagePreview && (
              <IconButton
                component="label"
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "#fff",
                  boxShadow: 1,
                  zIndex: 2,
                }}
              >
                <input
                  hidden
                  accept="image/jpeg, image/jpg, image/png"
                  type="file"
                  onChange={handleImageUpload}
                />
                <PhotoCamera />
              </IconButton>
            )}

            {/* ❌ Cancel icon only when imagePreview exists */}
            {imagePreview && (
              <IconButton
                onClick={handleImageRemove}
                sx={{
                  position: "absolute",
                  top: 5,
                  right: 5,
                  backgroundColor: "#fff",
                  color: "red",
                  border: "1px solid red",
                  padding: "2px",
                  zIndex: 3,
                  "&:hover": {
                    backgroundColor: "#ffe6e6",
                  },
                }}
                size="small"
              >
                <Cancel fontSize="small" />
              </IconButton>
            )}
          </Box>

          <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: "bold", color: "#000" }}>
            Upload Profile Image
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
            Allowed *.jpeg, *.jpg, *.png
          </Typography>
        </Box>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Basic Info
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtUserName}
                handleChange={formik.handleChange}
                name="txtUserName"
                placeholder="Enter User Name"
                displayName="User Name"
                required={true}
                formik={formik}
                inputType="onlyString"
                maxLength={50}
              />
            </Grid>
            {meData?.role_id !== 3 && (
              <Grid item size={{ xs: 12, md: 4 }}>
                <MDAutocomplete
                  label="Role"
                  name="intRoleID"
                  options={roleData}
                  formik={formik}
                  required={true}
                />
              </Grid>
            )}
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtEmail}
                handleChange={formik.handleChange}
                name="txtEmail"
                placeholder="Enter Email"
                displayName="Email"
                required={true}
                formik={formik}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.intPhone}
                handleChange={formik.handleChange}
                name="intPhone"
                placeholder="Enter Mobile Number"
                displayName="Mobile Number"
                required={true}
                formik={formik}
                inputType="numeric"
                maxLength={10}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtAddress}
                handleChange={formik.handleChange}
                name="txtAddress"
                placeholder="Permanent Address"
                displayName="Permanent Address"
                required={true}
                formik={formik}
                maxLength={250}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDAutocomplete
                label="District"
                name="txtDistrict"
                options={districtData}
                formik={formik}
                required={true}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.intAadharno}
                handleChange={formik.handleChange}
                name="intAadharno"
                placeholder="Enter Aadhar Number"
                displayName="Aadhar Number"
                required={true}
                formik={formik}
                inputType="numeric"
                maxLength={12}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                name="intPanNo"
                placeholder="Enter PAN Number"
                displayName="PAN Number"
                required
                formik={formik}
                maxLength={10}
                error={formik.touched.intPanNo && formik.errors.intPanNo}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  formik.setFieldValue("intPanNo", value);
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Educational Details
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtQualification}
                handleChange={formik.handleChange}
                name="txtQualification"
                placeholder="Enter Qualification"
                displayName="Qualification"
                required={true}
                formik={formik}
                maxLength={100}
              />
            </Grid>
          </Grid>
        </MDBox>

        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            About You
          </MDTypography>
        </MDBox>

        <MDBox p={2}>
          <Grid item size={{ xs: 12, md: 12 }}>
            <TextField
              fullWidth
              label="Bio"
              name="txtBio"
              value={formik.values.txtBio}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={Boolean(formik.touched.txtBio && formik.errors.txtBio)}
              helperText={
                formik.touched.txtBio && formik.errors.txtBio
                  ? formik.errors.txtBio
                  : `${formik.values.txtBio.length}/1000`
              }
              multiline
              rows={5}
              inputProps={{ maxLength: 1000 }}
              FormHelperTextProps={{
                sx: {
                  textAlign: "right",
                  marginRight: 0,
                  display: "block",
                  fontSize: "0.75rem", // optional
                },
              }}
            />
          </Grid>
        </MDBox>

        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Bank Info
          </MDTypography>
        </MDBox>

        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtBankName}
                handleChange={formik.handleChange}
                name="txtBankName"
                placeholder="Enter Bank Name"
                displayName="Bank Name"
                required={true}
                formik={formik}
                maxLength={50}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtIfscCode}
                handleChange={formik.handleChange}
                name="txtIfscCode"
                placeholder="Enter IFSC Code"
                displayName="IFSC Code"
                required={true}
                formik={formik}
                maxLength={50}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtBranch}
                handleChange={formik.handleChange}
                name="txtBranch"
                placeholder="Enter Branch"
                displayName="Branch"
                required={true}
                formik={formik}
                maxLength={50}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtAccountNumber}
                handleChange={formik.handleChange}
                name="txtAccountNumber"
                placeholder="Enter Account Number"
                displayName="Account Number"
                required={true}
                formik={formik}
                inputType="numeric"
                maxLength={50}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                error={formik.errors.txtAccountName}
                handleChange={formik.handleChange}
                name="txtAccountName"
                placeholder="Enter Account Name"
                displayName="Account Holder Name"
                required={true}
                formik={formik}
                maxLength={50}
              />
            </Grid>
          </Grid>
        </MDBox>
        {userId && (meData?.role_id === 1 || meData?.role_id === 2) && (
          <>
            <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h5" fontWeight="medium">
                Status
              </MDTypography>
            </MDBox>
            <MDBox p={2}>
              <Grid container spacing={3}>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <MDAutocomplete
                    label="Status"
                    name="intStatus"
                    options={statusData}
                    formik={formik}
                    required={true}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </>
        )}
        {/* Submit */}
        <MDBox p={2}>
          <Grid item size={{ xs: 12, md: 4 }}>
            <Grid item xs={12} md={12} textAlign="right">
              <MDButton
                // color="#2f2f34 !important"
                onClick={formik.handleSubmit}
                sx={{
                  color: "white !important",
                  backgroundColor: "#16610E",
                  "&:hover": {
                    backgroundColor: "#1f1f22", // optional: darker on hover
                  },
                }}
              >
                {userId ? "Update" : "Submit"}
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        {/* </Grid> */}
        {/* </form> */}
      </Card>
      {/* </LocalizationProvider> */}
      {/* </MDBox> */}
      {/* </Card> */}
    </DashboardLayout>
  );
}
